<div class="app-main__inner">

  <!-- ========== LIST VIEW ========== -->
  <div *ngIf="view === 'list'" class="bb-list-view">
    <div class="card bb-fill-card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <span class="fw-semibold"><i class="pe-7s-folder me-2 text-primary"></i>Categories List</span>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-secondary">{{ records.length }} records</span>
          <button type="button" class="btn btn-primary btn-sm" (click)="addNew()">
            <i class="pe-7s-plus me-1"></i> Add New Category
          </button>
        </div>
      </div>
      <div class="card-body p-0 bb-fill-body">
        <div class="text-center py-5" *ngIf="isListLoading">
          <div class="spinner-border text-primary"></div>
          <p class="mt-2 text-muted">Loading categories...</p>
        </div>
        <vio-table-v2 *ngIf="!isListLoading" [tableData]="records" [tableConfig]="tableConfig"></vio-table-v2>
      </div>
    </div>
  </div>

  <!-- ========== FORM VIEW ========== -->
  <div *ngIf="view === 'form'" class="bb-form-view">
    <div class="bb-form-card">

      <div class="bb-form-header">
        <div class="bb-form-header__title">
          <i class="pe-7s-folder"></i>
          {{ isEditMode ? 'Edit Category' : 'New Category' }}
        </div>
        <button type="button" class="bb-form-header__back" (click)="backToList()">
          <i class="pe-7s-angle-left"></i> Back
        </button>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="bb-form-body">
          <div class="row g-2">
            <div class="col-md-6">
              <label class="form-label">Category Name <span class="text-danger">*</span></label>
              <input type="text" formControlName="categoryName" class="form-control"
                     [class.is-invalid]="isFieldInvalid('categoryName')"
                     placeholder="e.g. कथा, विज्ञान, इतिहास"
                     (blur)="onCategoryNameBlur()" />
              <div class="invalid-feedback">
                <span *ngIf="f['categoryName'].errors?.['required']">Category name is required.</span>
                <span *ngIf="f['categoryName'].errors?.['minlength']">Must be at least 2 characters.</span>
              </div>
              <div class="bb-dup-panel" *ngIf="nameSuggestions.length > 0">
                <div class="bb-dup-header">
                  <i class="pe-7s-search"></i>
                  <span>{{ nameSuggestions.length }} existing categor{{ nameSuggestions.length === 1 ? 'y' : 'ies' }} found</span>
                  <button type="button" class="bb-dup-dismiss" (click)="dismissNameSuggestions()">
                    <i class="pe-7s-close"></i>
                  </button>
                </div>
                <div class="bb-dup-list">
                  <div class="bb-dup-item" *ngFor="let s of nameSuggestions">
                    <span class="bb-dup-name">{{ s.categoryName }}</span>
                    <span class="bb-dup-author" *ngIf="s.categoryNameEnglish">{{ s.categoryNameEnglish }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Category Name (English)</label>
              <input type="text" formControlName="categoryNameEnglish" class="form-control"
                     [class.is-invalid]="isFieldInvalid('categoryNameEnglish')"
                     placeholder="Auto-filled or type manually" />
              <div class="invalid-feedback">Max 150 characters.</div>
              <div class="bb-dup-panel" *ngIf="englishNameSuggestions.length > 0">
                <div class="bb-dup-header">
                  <i class="pe-7s-search"></i>
                  <span>{{ englishNameSuggestions.length }} existing categor{{ englishNameSuggestions.length === 1 ? 'y' : 'ies' }} found</span>
                  <button type="button" class="bb-dup-dismiss" (click)="dismissEnglishNameSuggestions()">
                    <i class="pe-7s-close"></i>
                  </button>
                </div>
                <div class="bb-dup-list">
                  <div class="bb-dup-item" *ngFor="let s of englishNameSuggestions">
                    <span class="bb-dup-name">{{ s.categoryName }}</span>
                    <span class="bb-dup-author" *ngIf="s.categoryNameEnglish">{{ s.categoryNameEnglish }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bb-form-footer">
          <div class="bb-form-footer__msg">
            <span *ngIf="errorMessage" class="text-danger"><i class="pe-7s-close-circle me-1"></i>{{ errorMessage }}</span>
            <span *ngIf="successMessage" class="text-success"><i class="pe-7s-check me-1"></i>{{ successMessage }}</span>
          </div>
          <button type="submit" class="bb-btn-save" [disabled]="isSaving">
            <span *ngIf="!isSaving"><i class="pe-7s-diskette"></i> {{ isEditMode ? 'Update' : 'Save' }}</span>
            <span *ngIf="isSaving" class="d-flex align-items-center gap-1"><span class="spinner-border spinner-border-sm"></span> Saving...</span>
          </button>
        </div>
      </form>

    </div>
  </div>

</div>

<!-- ── Category Books Modal ───────────────────────────────────────────────── -->
<div class="cb-backdrop" *ngIf="showCategoryBooksModal" (click)="closeCategoryBooksModal()"></div>
<div class="cb-modal" *ngIf="showCategoryBooksModal" (click)="$event.stopPropagation()">

  <div class="cb-modal-header">
    <div class="cb-modal-title">
      <i class="pe-7s-folder me-2 text-primary"></i>Books in {{ selectedCategoryForBooks?.categoryName }}
    </div>
    <button type="button" class="cb-close-btn" (click)="closeCategoryBooksModal()">
      <i class="pe-7s-close"></i>
    </button>
  </div>

  <div class="cb-modal-body">

    <div class="text-center py-4" *ngIf="isLoadingCategoryBooks">
      <div class="spinner-border text-primary spinner-border-sm"></div>
      <p class="text-muted small mt-2">Loading books…</p>
    </div>

    <div class="alert alert-danger py-2 px-3 small" *ngIf="categoryBooksError">
      <i class="pe-7s-attention me-1"></i>{{ categoryBooksError }}
    </div>

    <div class="text-center py-4 text-muted small"
         *ngIf="!isLoadingCategoryBooks && !categoryBooksError && categoryBooks.length === 0">
      No books found for this category.
    </div>

    <div class="cb-book-list" *ngIf="!isLoadingCategoryBooks && categoryBooks.length > 0">
      <p class="text-muted small mb-2">{{ categoryBooks.length }} title(s) found</p>

      <div class="cb-book-card" *ngFor="let book of categoryBooks">
        <div class="cb-book-header">
          <div class="cb-book-icon"><i class="pe-7s-notebook"></i></div>
          <div class="cb-book-info">
            <div class="cb-book-name">{{ book.bookName }}</div>
            <div class="cb-book-meta">
              <span class="cb-code" *ngIf="book.bookId">{{ book.bookId }}</span>
            </div>
          </div>
          <div class="cb-stats">
            <span class="cb-stat cb-stat-c" title="At Center">⌂ {{ book.available }}</span>
            <span class="cb-stat cb-stat-m" title="Issued">⇌ {{ book.issued }}</span>
          </div>
          <button class="cb-view-btn" (click)="openCopiesModal(book)">
            <i class="pe-7s-map-marker me-1"></i> View Copies
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- ── Copies Modal (stacks over category books modal) ────────────────────── -->
<div class="cb-cm-backdrop" *ngIf="showCopiesModal" (click)="closeCopiesModal()"></div>
<div class="cb-cm-modal" *ngIf="showCopiesModal" (click)="$event.stopPropagation()">

  <div class="cb-cm-header">
    <div class="cb-cm-title">
      <i class="pe-7s-map-marker me-2 text-primary"></i>Copy Locations
    </div>
    <button type="button" class="cb-close-btn" (click)="closeCopiesModal()">
      <i class="pe-7s-close"></i>
    </button>
  </div>

  <div class="cb-cm-book-strip">
    <div class="cb-cm-book-icon"><i class="pe-7s-notebook"></i></div>
    <div class="cb-cm-book-info">
      <div class="cb-cm-book-name">{{ selectedCopiesBook?.bookName }}</div>
      <div class="cb-cm-book-meta">
        <span class="cb-code" *ngIf="selectedCopiesBook?.bookId">{{ selectedCopiesBook.bookId }}</span>
        <span class="cb-cm-author" *ngIf="selectedCopiesBook?.authorNames?.length">
          {{ selectedCopiesBook.authorNames.join(', ') }}
        </span>
      </div>
    </div>
    <div class="cb-stats">
      <span class="cb-stat cb-stat-c" title="At Center">⌂ {{ selectedCopiesBook?.available }}</span>
      <span class="cb-stat cb-stat-m" title="Issued">⇌ {{ selectedCopiesBook?.issued }}</span>
      <span class="cb-stat cb-stat-t" title="Total">&#x2022; {{ selectedCopiesBook?.totalCopies }}</span>
    </div>
  </div>

  <div class="cb-cm-body">
    <div class="cb-no-copies text-muted small" *ngIf="!selectedCopiesBook?.copies?.length">
      No inventory copies found for this book.
    </div>
    <table class="table table-sm cb-cm-copies-table mb-0" *ngIf="selectedCopiesBook?.copies?.length">
      <thead>
        <tr><th>Sr No.</th><th>Status</th><th>Location</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let copy of selectedCopiesBook?.copies" [class]="catBookRowClass(copy.status)">
          <td class="cb-srno">{{ copy.bookSrNo }}</td>
          <td>
            <span class="cb-status-badge" [ngClass]="'cb-badge-' + copy.status">
              {{ catBookStatusLabel(copy.status) }}
            </span>
          </td>
          <td class="cb-location">{{ copy.location }}</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
